export const generateSlug = (str) => {
  return str
    .toLowerCase() // Converte para minúsculas
    .trim() // Remove espaços extras no início e fim
    .replace(/\s+/g, "-") // Substitui espaços por hífens
    .replace(/[^\w-]+/g, ""); // Remove caracteres especiais
};
